<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totalDateRange | moneyNoDecimal(currency) }}</h2>
                <span>Total <small>(Data Selecionada, Bruto)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ avgDateRange | moneyNoDecimal(currency) }}</h2>
                <span>Média Diária <small>(Data Selecionada, Bruto)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ refundsDateRange | money(currency) }}</h2>
                <span>Devoluções <small>(Data Selecionada)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <div v-for="plan in ordersBreakdownByPlan" :key="plan.id">
                  <h4>
                    <div class="inline-block font-bold mr-4">{{ plan.total | moneyNoDecimal(currency) }}</div>
                    <div class="inline-block text-sm">{{ plan.name }}</div>
                  </h4>
                </div>
                <span>Por Plano</span>
                <div><span><small>(Data Selecionada, Bruto, Sem Descontos)</small></span></div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ totalCurrentMonth | moneyNoDecimal(currency) }}</h2>
                <span>Total do Mês Atual <small>(Bruto)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ avgCurrentMonth | moneyNoDecimal(currency) }}</h2>
                <span>Média Diária <small>(Mês Atual, Bruto)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ refundsCurrentMonth | money(currency) }}</h2>
                <span>Devoluções <small>(Mês Atual)</small></span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ forecastCurrentMonth | moneyNoDecimal(currency) }}</h2>
                <span>Previsão Mês Atual</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="stripeActive">
        <vx-card class="overflow-hidden mb-4" :class="{'bg-danger': stripe.needsResponseCount > 0}">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <a
                href="https://dashboard.stripe.com/disputes?statuses%5B%5D=needs_response&statuses%5B%5D=warning_needs_response&evidence_due_by%5Bgt%5D=1622257200&sort=evidence_due_by&order=asc"
                target="_blank" :class="{'text-white': stripe.needsResponseCount > 0}">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-danger"
                  :class="{'text-white': stripe.needsResponseCount > 0}"
                  style="background: rgba(var(--vs-danger),0.15);"
                >
                <i class="fab fa-stripe fa-2x"></i>
              </span>
              </a>
              <div class="truncate" :class="{'text-white': stripe.needsResponseCount > 0}">
                <h2 class="mb-1 font-bold">
                  <a href="https://dashboard.stripe.com/disputes?statuses%5B%5D=needs_response&statuses%5B%5D=warning_needs_response&evidence_due_by%5Bgt%5D=1622257200&sort=evidence_due_by&order=asc"
                     target="_blank"
                     :class="{'text-white': stripe.needsResponseCount > 0}">{{ stripe.needsResponseCount }}</a> <span :class="{'text-white': stripe.needsResponseCount > 0 || stripe.needsResponseCount > 0}">&nbsp;/&nbsp;</span>
                  <a href="https://dashboard.stripe.com/disputes?statuses%5B%5D=under_review&statuses%5B%5D=warning_under_review&evidence_due_by%5Bgt%5D=1622257200&sort=evidence_due_by&order=asc"
                    target="_blank">{{ stripe.underReview }}</a>
                </h2>
                <a
                  href="https://dashboard.stripe.com/disputes?statuses%5B%5D=needs_response&statuses%5B%5D=warning_needs_response&evidence_due_by%5Bgt%5D=1622257200&sort=evidence_due_by&order=asc"
                  target="_blank" :class="{'text-white': stripe.needsResponseCount > 0}"><abbr
                  title="Stripe Disputas Sem Comprovante"><span>Disputas Sem Comprovante/Em Análise</span></abbr></a><br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="stripeActive">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center font-weight-bold">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-primary"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                <i class="fab fa-stripe fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ stripe.subscriptionsActive }}</h2>
                Assinaturas Ativas<br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="iuguActive">
        <vx-card class="overflow-hidden mb-4" :class="{'bg-danger': iugu.needsResponseCount > 0}">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center font-weight-bold">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-primary"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                Iugu
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">
                  <a href="https://alia.iugu.com/receive/disputes"
                     target="_blank"
                     :class="{'text-white': iugu.needsResponseCount > 0}">{{ iugu.needsResponseCount || '0' }}</a>
                </h2>
                <span :class="{'text-white': iugu.needsResponseCount > 0}">Dispustas Pendentes</span><br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="iuguActive">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center font-weight-bold">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-primary"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                Iugu
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ iugu.subscriptionsActive }}</h2>
                Assinaturas Ativas<br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="payPalActive">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center font-weight-bold">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-primary"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                <i class="fab fa-paypal fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ paypal.subscriptionsActive }}</h2>
                Assinaturas Ativas<br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4" v-show="pagarmeActive">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center font-weight-bold">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative mb-4 text-primary"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                pagar.me
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ pagarme.subscriptionsActive }}</h2>
                Assinaturas Ativas<br>
                <small class="text-muted">(atualiza a cada 10 minutos)</small>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex mb-2 px-2">
        <div class="w-full md:w-4/12">
          <div class="flex">
            <div class="flex-1 px-2">
              <Datepicker
                :language="ptBR"
                placeholder="Data Inicial"
                :use-utc="true"
                format="dd/MM/yyyy"
                v-model="created_at_start"/>
            </div>
            <div class="flex-1 px-2">
              <Datepicker
                :language="ptBR"
                placeholder="Data Final"
                :use-utc="true"
                format="dd/MM/yyyy"
                v-model="created_at_end"/>
            </div>
          </div>
        </div>
        <div class="w-full md:w-8/12">
          <vs-pagination :max="10" :total="orders.last_page" v-model="orders.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado na data selecionada"
        @selected="handleClick"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="header">
          <h3>Vendas do Dia</h3>
        </template>
        <template slot="thead">
          <vs-th>NÚMERO</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>BRUTO</vs-th>
          <vs-th>LÍQUIDO</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>PAGAMENTO</vs-th>
          <vs-th>HORA</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].number">
              <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].id } }">{{ data[idx].number }}
              </router-link>
            </vs-td>
            <vs-td v-if="data[idx].user" :data="data[idx].user.email">
              <router-link
                :to="{ name: 'cliente-detalhes', params: { id: data[idx].user.id } }"
              >{{ data[idx].user.email }}
              </router-link>
            </vs-td>
            <vs-td v-if="!data[idx].user">-</vs-td>
            <vs-td :data="data[idx].subtotal">{{ data[idx].subtotal | money(currency) }}</vs-td>
            <vs-td :data="data[idx].total">{{ data[idx].total | money(currency) }}</vs-td>
            <vs-td :data="data[idx].payment_method">{{ data[idx].payment_method }}</vs-td>
            <vs-td :data="data[idx].status">{{ data[idx].status }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatTime }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="w-full">
        <vs-pagination :total="orders.last_page" v-model="orders.current_page"></vs-pagination>
      </div>
    </div>

    <em>Nota: Valor de totais e médias são líquidos.</em><br>
  </div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ptBR,
      created_at_start: moment().format('YYYY-MM-DD'),
      created_at_end: moment().format('YYYY-MM-DD'),
      data: [],
      orders: {
        current_page: 1,
        last_page: 1
      },
      ordersBreakdownByPlan: [],
      totalDateRange: 0,
      avgDateRange: 0,
      refundsDateRange: 0,
      totalCurrentMonth: 0,
      avgCurrentMonth: 0,
      refundsCurrentMonth: 0,
      forecastCurrentMonth: 0,
      iugu: {
        subscriptionsActive: '-'
      },
      paypal: {
        subscriptionsActive: '-'
      },
      stripe: {
        subscriptionsActive: '-',
        needsResponseCount: '-',
        underReview: '-'
      },
      pagarme: {
        subscriptionsActive: '-'
      },
      iuguActive: process.env.VUE_APP_IUGU_ACTIVE === 'true',
      pagarmeActive: process.env.VUE_APP_PAGARME_ACTIVE === 'true',
      payPalActive: process.env.VUE_APP_PAYPAL_ACTIVE === 'true',
      stripeActive: process.env.VUE_APP_STRIPE_ACTIVE === 'true',
      currency: 'BRL',
    }
  },

  mounted() {
    this.currency = localStorage.getItem('currency') || 'USD'
    this.load()
  },

  watch: {
    'orders.current_page'() {
      this.load()
    },
    created_at_start() {
      this.load()
    },
    created_at_end() {
      this.load()
    }
  },

  methods: {
    load() {
      this.$vs.loading()

      this.$api
      .get('/api/v1/backend/dashboard?currency=' + this.currency, {
        params: {
          page: this.orders.current_page,
          created_at_start: this.created_at_start,
          created_at_end: this.created_at_end
        }
      })
      .then(response => {
        this.$vs.loading.close()
        this.orders = response.data.orders
        this.ordersBreakdownByPlan = response.data.ordersBreakdownByPlan
        this.data = response.data.orders.data
        this.totalDateRange = response.data.totalDateRange
        this.avgDateRange = response.data.avgDateRange
        this.refundsDateRange = response.data.refundsDateRange
        this.totalCurrentMonth = response.data.totalCurrentMonth
        this.avgCurrentMonth = response.data.avgCurrentMonth
        this.refundsCurrentMonth = response.data.refundsCurrentMonth
        this.forecastCurrentMonth = response.data.forecastCurrentMonth
        this.stripe = response.data.stripe
        this.iugu = response.data.iugu
        this.paypal = response.data.paypal
        this.pagarme = response.data.pagarme
      })
      .catch(() => {
        this.$vs.loading.close()
      })
    },
    handleClick(row) {
      this.$router.push({name: 'venda-detalhes', params: {id: row.id}})
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.text-muted {
  color: #ccc;
}
</style>
